export const componentModule = {

    state() {
        return {
            sliders: {
                uk: [],
                ru: []
            },
            whies: [],
            development: {
                uk: [],
                ru: [],
                data: null,
            },
            productions: {
                uk: [],
                ru: [],
            },
            company: [],
            partner: {
                data: null,
                uk: [],
                ru: [],
            },
            OurProducts: {
                data: null,
                uk: [],
                ru: [],
            }
        }
    },

    getters: {
        sliderHome(state) {
            return state.sliders
        },
        whies(state) {
            return state.whies
        },
        productions(state) {
            return state.productions
        },
        company(state) {
            return state.company
        },
        partner(state) {
            return state.partner
        },
        OurProducts(state) {
            return state.OurProducts
        },
        development(state) {
            return state.development
        }
    },

    mutations: {
        setSliders(state, data) {
            state.sliders.uk = JSON.parse(data.sliders['uk']);
            state.sliders.ru = JSON.parse(data.sliders['ru']);
        },
        setWhies(state, data) {
            state.whies = data.whies
        },
        setProductions(state, data) {
            state.productions.uk = JSON.parse(data.productions['uk']);
            state.productions.ru = JSON.parse(data.productions['ru']);
        },
        setCompany(state, data) {
            state.company = data.company
        },
        setPartner(state, data) {
            state.partner.data = data.partner.data
            state.partner.uk = data.partner.uk
            state.partner.ru = data.partner.ru
        },
        setOurProducts(state, data) {

            state.OurProducts.data = JSON.parse(data['our-products'].data)
            state.OurProducts.uk = JSON.parse(data['our-products'].uk)
            state.OurProducts.ru = JSON.parse(data['our-products'].ru)
        },
        setDevelopment(state, data) {
            state.development.data = data.development.developments
            state.development.uk = data.development.data.uk
            state.development.ru = data.development.data.ru
        }

    },

    actions: {
        async getComponents({ commit }) {
            await axios.get('/api/components').then((res) => {
                commit('setSliders', res.data);
                commit('setProductions', res.data);
                commit('setWhies', res.data);
                commit('setCompany', res.data);
                commit('setPartner', res.data);
                commit('setOurProducts', res.data);
                commit('setDevelopment', res.data);
            }).catch((err) => {

            })
        },
    },

    namespaced: true,
}